import { useState } from "react";
import { useAccountSendResetPasswordEmail } from "@made-people/grease-account";
import { useTranslate } from "@made-people/grease-translations";

export const useResetPasswordForm = ({
  onEmailSent,
}: {
  onEmailSent: () => void;
}) => {
  const translate = useTranslate();
  const { execute, loadingState } = useAccountSendResetPasswordEmail();

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (loadingState === "loading") return;
    setError("");
    const result = await execute({ email });
    if (result.success) {
      onEmailSent();
    } else if (result.error === "Account_InvalidEmail") {
      setError(translate("Account_InvalidEmail_Helper_Text"));
    } else {
      setError(translate(result.error));
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return {
    email,
    setEmail,
    error,
    handleSubmit,
    handleKeyDown,
    loadingState,
  };
};
